import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {SupportComponent} from './components/support.component';


const routes: Routes = [
    {
        path: ':slug1/:slug2/:slug3',
        component: SupportComponent,
        data: {
            title: $localize `:@@support.support:Help center`
        }
    },
    {
        path: ':slug1/:slug2',
        component: SupportComponent,
        data: {
            title: $localize `:@@support.support:Help center`
        }
    },
    {
        path: ':slug1',
        component: SupportComponent,
        data: {
            title: $localize `:@@support.support:Help center`
        }
    },
    {
        path: '',
        component: SupportComponent,
        data: {
            title: $localize `:@@support.support:Help center`
        }
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class SupportRoutingModule { }
